import { render } from "./students.vue?vue&type=template&id=a254be66&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"

import "./students.vue?vue&type=style&index=0&id=a254be66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a254be66"]])

export default __exports__